const LOCALE = 'it-CH'

const toDate = (value: string | number | Date | null | undefined): Date | null => {
  if (value === null || value === undefined || value === '') return null
  const d = value instanceof Date ? value : new Date(value)
  return isNaN(d.getTime()) ? null : d
}

export const formatDate = (value: string | number | Date | null | undefined): string => {
  const d = toDate(value)
  return d ? d.toLocaleDateString(LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''
}

// Long form with weekday and month name (e.g. a dashboard clock banner).
export const formatDateLong = (value: string | number | Date | null | undefined): string => {
  const d = toDate(value)
  return d ? d.toLocaleDateString(LOCALE, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) : ''
}

export const formatDateTime = (value: string | number | Date | null | undefined): string => {
  const d = toDate(value)
  return d ? d.toLocaleString(LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit',
                                        minute: '2-digit' }) : ''
}

// Time only, no date part (e.g. a live clock).
export const formatTime = (value: string | number | Date | null | undefined): string => {
  const d = toDate(value)
  return d ? d.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' }) : ''
}

export const formatNumber = (value: number | null | undefined, opts?: Intl.NumberFormatOptions): string =>
  value === null || value === undefined || isNaN(value) ? '' : new Intl.NumberFormat(LOCALE, opts).format(value)

export const formatCurrency = (value: number | null | undefined, currency = 'CHF'): string =>
  formatNumber(value, { style: 'currency', currency })
